var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8878 34.916C73.265 32.603 71.4413 30.7792 69.1283 30.1565C64.9026 29 47.9999 29 47.9999 29C47.9999 29 31.0972 29 26.8715 30.112C24.603 30.7348 22.7348 32.603 22.112 34.916C21 39.1416 21 47.9044 21 47.9044C21 47.9044 21 56.7116 22.112 60.8928C22.7348 63.2058 24.5585 65.0295 26.8715 65.6522C31.1416 66.8087 47.9999 66.8087 47.9999 66.8087C47.9999 66.8087 64.9026 66.8087 69.1283 65.6967C71.4413 65.074 73.265 63.2503 73.8878 60.9373C74.9998 56.7116 74.9998 47.9488 74.9998 47.9488C74.9998 47.9488 75.0443 39.1416 73.8878 34.916Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6172 55.9996L56.6731 47.9041L42.6172 39.8086V55.9996Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.57c827057bae4a9608ba26c34ad8ef24.svg";
export { ForwardRef as ReactComponent };